<script lang="ts">
    import { useNavigate } from 'svelte-navigator';
    import authStore from '../../store/auth';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import { getOtp as GetOTP } from '../../domain/auth/login.action'
    import { ICONS, parseMobile, defaultCountry, countries } from '../../services/utils'
    import Header from '../../components/Header.svelte';
    import Footer from '../../components/Footer.svelte';
    import toast from '../../services/toast';
    import Icon from '../../components/Icon.svelte';
    import { fly } from 'svelte/transition';
    import { backOut } from 'svelte/easing';

    const navigate = useNavigate();
    
    let phone = ""
    let loading = false
    let dropdown = null;
    let errors: any = {}
    let country = defaultCountry;



    const isValidPhone = phone => {
        const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/, "gm");
        return phoneRegex.test(phone);
    }

    const handleSelectCountry = _country => {
        country = _country
        dropdown = null
    }

    const getOtp = async (scheme="SMS") => {
        errors = {};
        const mobile = parseMobile(phone, country.tel)
        if (!mobile || (mobile && !isValidPhone(mobile))) {
            errors.phone = "Phone is required";
            toast.error({message: errors.phone});
            return
        }
        loading = true
        try {
            const response = await GetOTP(mobile, scheme)
            authStore.setMobile(mobile);
            navigate("/otp")
        } catch (e) {
            const { message = "An error occured"} = e
            errors.review = message
            toast.error({message});
        } finally {
            loading = false
        }
        
    }

    $: {
        if (
            $authStore.isLoggedIn
        ) {
            navigate("/choose-business")
        }
    }
    
</script>


{#if dropdown}
<div class="absolute w-full z-20 top-0 bottom-0 bg-gray-700/50" transition:fly>
  {#if dropdown === 1}
    <div class="p-4 rounded-lg m-4 mt-16 shadow-xl bg-white" in:fly={{
      y: -100,
      delay: 100,
      easing: backOut
    }} style="overflow: hidden;">
      <div class="flex justify-between w-full items-center">
        <span class="text-black">Select country code</span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer" on:click={() => dropdown = null}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.75684 13.2426L13.2421 4.75736" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.2421 13.2426L4.75684 4.75735" stroke="#173556" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>        
        </span>
      </div>

      {#if countries.length > 0}
        <div class="flex flex-col overflow-y-scroll" style="max-height: 60vh;">
            <ul>
                {#each countries as country}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li class="flex justify-between items-center my-3 py-2 hover:bg-gray-100 hover:shadow-sm" on:click={() => handleSelectCountry(country)}>
                        <div>
                            <div class="flex text-gray-900">
                                <img src={ICONS[country.code?.toLowerCase()]} alt="{country.code}-logo" width="20px" style="height: 20px"  />
                                &nbsp;
                                { country.name }
                            </div>
                        </div>
                        <div>
                            { country.tel }
                        </div>
                    </li>
                {/each}
            </ul>
        </div>
      {:else}
        <div class="mb-4 text-xs text-center mt-4">
            No country available
        </div>
      {/if}
    </div>
  {/if}
</div>
{/if}

<Header/>
<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex w-full">
            <div class="flex flex-col w-full">
                
                <div class="relative mx-8 mt-16 mb-8 text-gray-400">
                    <strong class="secondary-text-color text-xl">
                        Sign in to PressOne
                    </strong>
                    <br/>
                    <span class="text-xs primary-text-color">Enter your registered phone number</span>

                    <div class="mt-4">
                        <span class="text-xs">
                            Phone Number
                        </span>
                        <div class="w-full">
                            <div class="border-b border-black w-full mr-2 flex">
                                <!-- svelte-ignore a11y-click-events-have-key-events -->
                                <span class="flex items-center" on:click={() => dropdown = 1}>
                                    <span class="rounded-full overflow-hidden w-5 h-5 items-center cursor-pointer">
                                        <img src={ICONS[country.code?.toLowerCase()]} alt="{country.code}-logo" width="20px" style="height: 20px"  />
                                    </span> &nbsp;
                                    <Icon size="12" color="#aaa" icon="toggle"/>
                                </span>
                                <span class="text-sm ml-2 flex items-center">{ country.tel }</span>
                                <input
                                    placeholder="Enter phone number"
                                    bind:value={phone}
                                    class="border-0 p-2 text-sm text-gray-800"
                                />
                            </div>
                            <small class="mb-4 primary-text-color text-xs">An OTP will be sent to this number and your email</small>
                            {#if errors.phone}
                            <div><small class="text-xs text-red-500">{ errors.phone }</small></div>
                            {/if}
                            <ButtonRounded
                                loading={loading}
                                on:click={() => getOtp("SMS")}
                                size=8
                                title=""
                                className="call-btn-bg-color h-10 mt-4 w-full flex-inline text-white px-8"
                            >
                            Continue
                            </ButtonRounded>
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div class="mt-2 text-sky-500 cursor-pointer text-center" on:click={() => getOtp("VOICE")}>Call me instead</div>
                        </div>
                        {#if errors.review}
                            <small class="text-xs text-red-500">{ errors.review }</small>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<Footer/>
<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
</style>
